import styled from 'styled-components';

const CounterReset = styled.div`
  counter-reset: section;
`;

export default CounterReset;
